/* @ngInject */
export default function (logService) {
  if (logService.isLogStreamEnabled()) {
    logService.startIntervalSendLogs();
  }
}
